<template>
  <v-expansion-panels tile multiple v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header color="primary">
        <v-row style="color: white">
          <v-col>
            <span>{{ $t('ELE0204') }}</span>
          </v-col>
          <v-col>
            <span>{{ $t('ELE0056') }}: {{ qrInformation.refNo }}</span>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <QrInformationForm :item="qrInformation" />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header color="primary">
        <v-row style="color: white">
          <v-col>
            <span>{{ $t('ELE0166') }}</span>
          </v-col>
          <v-col>
            <span>{{ qrInformation.partCd }}: {{ qrInformation.partName }}</span>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <PartsInspInformationForm :item="partsInformation" />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header color="primary">
        <v-row style="color: white">
          <v-col>
            <span>{{ $t('ELE0167') }}</span>
          </v-col>
          <v-col>
            <span>{{ $t('ELE0049') }}: {{ qrInformation.lotNo }}</span>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <LotInspInformationForm :item="lotInformation" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import QrInformationForm from '@/components/organisms/terminal/form/QrInformationForm.vue'
import PartsInspInformationForm from '@/components/organisms/terminal/form/PartsInspInformationForm.vue'
import LotInspInformationForm from '@/components/organisms/terminal/form/LotInspInformationForm.vue'

export default {
  name: 'QrPartLotInformationForm',

  components: { QrInformationForm, PartsInspInformationForm, LotInspInformationForm },

  props: {
    qrInformation: {
      type: Object,
      required: true,
    },
    partsInformation: {
      type: Object,
      required: true,
    },
    lotInformation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      panel: [0, 1, 2],
    }
  },
}
</script>
